<template>
    <div class="Popup" v-show="close">
        <div class="box">
            <div class="box1">
                <div class="cent">
                    <div class="cent_1" style="position: relative;">
                        <p class="title">共{{goodsArr.length}}门课程，您已完成{{finishNum}}门</p>
                        <p class="close" style="width: 0.3rem;height: 0.3rem; font-size: .34rem; font-weight: bold;position: absolute;right: 0%;top: 30%;"
                            @click="onclose">x</p>
                    </div>

                    <div class="cont clearfix" v-for="goods in goodsArr" @click="toStudy(goods.id)">
                        <div class="left">
                            <img :src="goods.picture" />
                        </div>
                        <div class="right">
                            <ul style="list-style: none;" class="text">
                                <li style="overflow:hidden;text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:1;"> {{goods.name}}</li>
                                <li class="list_s">
                                    <p> 共{{goods.chapter_number}}节</p>
                                    <p>时长:{{goods.total_duration}}</p>
                                    <p>{{goods.buy_number}}人学习</p>
                                </li>
                                <li class="list_st">
<!--                                    <p style="color: #FF773B;font-size: .28rem;" v-if="goods.goods_price > 0">￥{{goods.goods_price / 100}}</p>-->
<!--                                    <p style="color: #FF773B;font-size: .28rem;" v-else>免费</p>-->
                                    <!-- <p style="width: 1.36rem;height: .46rem;background: #078AFE;color: white;text-align: center;line-height: .46rem;border-radius: 5px;">立即购买</p>-->
                                    <p style="" v-if="goods.is_finish == 1">已完成</p>
                                    <p style="color: #078AFE;" v-else>未完成</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bus from '../bus.js'
    export default {
        name: "Popup",
        data() {
            return {
                close:false,
                goodsArr: [] // 商品信息
            }
        },
        computed: {
            finishNum: function(){
                if (!this.goodsArr || !this.goodsArr.length) return 0;
                var num = 0;
                for (var i in this.goodsArr) {
                    if (this.goodsArr[i].is_finish == 1) {
                        num++;
                    }
                }
                return num;
            }
        },
        methods: {
            onclose:function(fomes){
                bus.$emit('close',{close})
                this.close=false
            },
            toStudy: function(goodsId){
                //https://www.jinku.com/goods/video-11767/
                if (goodsId) location = 'https://m.jinku.com/org/video/?goods_id=' + goodsId
            }
        },
        created(){

        },
        mounted() {
            this.onclose();
            let then = this
            bus.$on('data', function(msg) {
                 then.close = true
			})
            bus.$on('show', function(goodsArr) {
                then.goodsArr = goodsArr
                then.close = true
            })
        }
    }
</script>

<style scoped>
    .box {
        width: 100%;
        height: 100%;
        background: #000000a6;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
    }
    .box1 {
        width: 100%;
        height: 10rem;
        position: absolute;
        bottom: 0;
        background: white;
        border-radius: .3rem .3rem 0 0;
        z-index: 999;
        overflow-y: auto;

    }

    .title {
        margin: .44rem 0;
        font-size: .28rem;
        color: #202020;
        font-weight: 500;
    }

    .cent {
        overflow-y: auto;
        margin: 0 .27rem 0 .3rem;
    }

    .clearfix:after {
        content: "";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }

    .cont {
        width: 100%;
        display: flex;
    }

    .left img {
        width: 2.42rem;
        height: 1.35rem;
    }

    .left {
        float: left;
        padding-right: .1rem;
    }

    .right {
        float: right;
        font-size: .26rem;
        flex: 1;
    }

    .list_s {
        display: flex;
    }

    .list_s p {
        margin-left: 0.2rem;
    }

    .list_st {
        display: flex;
        justify-content: space-between;
    }

    .cent_1 {
        display: flex;
        justify-content: space-between;
    }

    .text li p {
        font-size: .24rem;
        color: #999DAA;
    }

    .text li {
        margin-bottom: .19rem;
    }

    .lest_p {
        font-size: .28rem;
        color: #FF773B;
    }
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue